import { Editor } from 'react-draft-wysiwyg';
import { Col, Label } from 'reactstrap';

const EDITOR_TOOLBAR = {
    options: [
        'inline',
        'blockType',
        'fontSize',
        'list',
        'textAlign',
        'colorPicker',
        'link',
        'remove',
        'history',
    ],
    inline: {
        options: [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'monospace',
        ],
        bold: { className: 'bordered-option-classname' },
        italic: { className: 'bordered-option-classname' },
        underline: { className: 'bordered-option-classname' },
        strikethrough: { className: 'bordered-option-classname' },
        code: { className: 'bordered-option-classname' },
    },
    blockType: {
        className: 'bordered-option-classname',
    },
    fontSize: {
        className: 'bordered-option-classname',
    },
};

const DescriptionEditorField = ({
    t,
    labelKey,
    editorState,
    onChange,
    required = false,
}) => {
    return (
        <Col sm="12" className="mb-4">
            <Label>
                {t(labelKey)}:{required && <span className="text-danger"> *</span>}
            </Label>
            <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={onChange}
                toolbar={EDITOR_TOOLBAR}
            />
        </Col>
    );
};

export default DescriptionEditorField;
